import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useMemo } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Fade from '@mui/material/Fade';
import { toString } from 'lodash-es';
import PropTypes from 'prop-types';
import { StyledIconToolTipContentHeader, StyledIconToolTipContentLink, StyledIconTooltip, StyledIconWrap } from './IconTooltip.styles.js';
const _excluded = ["link", "header", "icon", "content", "interactive", "labelId", "placement", "classes", "withoutMaxWidth", "iconClasses", "onOpen", "onClose", "onClick", "disableFocusListener", "size", "customColor", "color", "black"];
function IconTooltip(_ref) {
  let {
      link,
      header,
      icon,
      content,
      interactive,
      labelId,
      placement,
      classes,
      withoutMaxWidth,
      iconClasses,
      onOpen,
      onClose,
      onClick,
      disableFocusListener,
      size,
      customColor,
      color,
      black
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const getIcon = icon || /*#__PURE__*/React__default.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  });
  const [isHover, setIsHover] = useState(false);
  const handleOpen = () => {
    setIsHover(true);
    onOpen();
  };
  const handleClose = () => {
    setIsHover(false);
    onClose();
  };
  const handleClick = () => {
    onClick();
  };
  const renderContent = useMemo(() => {
    if (!header && !content && !link) {
      return '';
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, header && /*#__PURE__*/React__default.createElement(StyledIconToolTipContentHeader, null, header), content, link && /*#__PURE__*/React__default.createElement(StyledIconToolTipContentLink, null, link));
  }, [header, content, link]);
  return /*#__PURE__*/React__default.createElement(StyledIconTooltip, _extends({}, otherProps, {
    title: renderContent,
    interactive: toString(interactive),
    placement: placement,
    onOpen: handleOpen,
    onClose: handleClose,
    TransitionComponent: Fade,
    withoutMaxWidth: withoutMaxWidth,
    disableFocusListener: disableFocusListener,
    "label-id": labelId,
    black: black
  }), /*#__PURE__*/React__default.createElement(StyledIconWrap, {
    className: iconClasses,
    isHover: isHover,
    onClick: handleClick,
    onKeyDown: null,
    tabIndex: "0",
    role: "button",
    size: size,
    color: color,
    customColor: customColor
  }, getIcon));
}
IconTooltip.propTypes = {
  link: PropTypes.node,
  header: PropTypes.node,
  icon: PropTypes.node,
  content: PropTypes.node,
  interactive: PropTypes.bool,
  withoutMaxWidth: PropTypes.bool,
  classes: PropTypes.string,
  iconClasses: PropTypes.string,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  disableFocusListener: PropTypes.bool,
  labelId: PropTypes.string,
  size: PropTypes.number,
  customColor: PropTypes.string,
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning', 'setting']),
  sx: PropTypes.shape({}),
  black: PropTypes.bool
};
IconTooltip.defaultProps = {
  icon: /*#__PURE__*/React__default.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  }),
  header: '',
  content: '',
  link: '',
  interactive: true,
  withoutMaxWidth: false,
  classes: '',
  iconClasses: '',
  onOpen: () => {},
  onClose: () => {},
  onClick: () => {},
  placement: 'top-start',
  disableFocusListener: true,
  labelId: undefined,
  size: 16,
  customColor: '',
  color: 'secondary',
  sx: {},
  black: false
};
export { IconTooltip as default };